import { defineStore } from 'pinia'
import { LoginServer, MenuListServer } from '@/api/login'
import router from '@/router'
import { addRouter } from '@/permission'
import { isUrl } from '@/utils/tools/Base'
import { userHomeStore } from './home.js'
import { encrypt } from '@/utils/crypto.js'
import { menusData } from '@/router/menu-config.js'

export const useLoginStore = defineStore('login', {
    state: () => ({
        loginInfo: {},
        userInfo: {},
        roleList: [],
        token: '',
        menuList: [],
        filedErrorType: null,
        userAvatar: ''
    }),
    getters: {},
    actions: {
        setFiledErrorType() {
            this.filedErrorType = null
        },
        async loginBtn(param) {
            param.password = encrypt(param.password)

            const response = await LoginServer(param)

            if (response?.success) {
                this.userInfo = response?.result?.userInfo
                this.token = response?.result?.token
                this.roleList = response?.result?.roleList

                this.loginInfo = param
                await this.getMenuList()

                const avatars = Array.from({ length: 15 }, (_, i) => `avatar${i + 1}.png`)

                // 检查 localStorage 中是否已有分配的头像
                const assignedAvatar = localStorage.getItem('userAvatar')

                if (!assignedAvatar) {
                    // 随机选择一个头像
                    const randomIndex = Math.floor(Math.random() * avatars.length)
                    this.userAvatar = avatars[randomIndex]

                    // 将选择的头像存入 localStorage
                    localStorage.setItem('userAvatar', this.userAvatar)
                } else {
                    // 如果已分配，直接使用
                    this.userAvatar = assignedAvatar
                }
            } else {
                if (response?.message === '该用户不存在，请注册') {
                    this.filedErrorType = 1
                }
                if (response?.message === '密码错误') {
                    this.filedErrorType = 2
                }
            }
        },
        async getMenuList() {
            // const response = await MenuListServer()
            // if (response?.success) {
            this.menuList = menusData

            // 在集合中寻找第一节点的path不为url的加载
            const list = this.menuList.find(e => {
                if (!isUrl(e.path) && e.url !== 'Layout' && e.show) {
                    return e
                }
            })

            this.openMenuChild(list)
            // }
        },

        // 登录后选中第一个节点
        openMenuChild(data) {
            const homeStore = userHomeStore()
            if (data.children && data.children.length !== 0) {
                if (data.url !== 'Layout') {
                    // 添加动态路由
                    addRouter(this.menuList)
                    // 默认选择第一个节点
                    homeStore.updateSelectKeys([`/${data.name}`])
                    router.push({
                        path: data.path
                    })
                } else {
                    homeStore.updateOpenKeys([data.icon])
                    this.openMenuChild(data.children[0])
                }
            } else {
                // 如果该默认集合中有children 第一节点在children中找
                // 如果该默认集合中没有children，第一节点就是自身
                homeStore.updateSelectKeys([`/${data.name}`])
                router.push({
                    path: data.path
                })
            }
        }
    },
    persist: {
        key: 'login-store',
        storage: localStorage,
        pick: ['userInfo', 'roleList', 'token', 'menuList']
    }
})
